module.exports = __webpack_public_path__ + "58fa0756dc31ff62b770e562592f66f2.png";